import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LatestEpisodeService } from './latest-episodes.service';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
    selector: 'app-latest-episodes',
    templateUrl: './latest-episodes.component.html',
    styleUrls: ['./latest-episodes.component.scss']
})
export class LatestEpisodesComponent implements OnInit {
    
    public analyze_videos: any[] = [];

    constructor(
        public router: Router,
        private content: LatestEpisodeService
    ) { 
        this.content.getLatestVideos().subscribe((videos) => {
            this.analyze_videos = videos;
          });
    }

    videoCarouselOptions: OwlOptions = {
        loop: false,
        margin: 16,
        nav: true,
        dots: false,
        navText: [
          '<i class="ri-arrow-left-s-line fs-3 text-dark"></i>',
          '<i class="ri-arrow-right-s-line fs-3 text-dark"></i>'
        ],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          }
        }
    };
      
      

    ngOnInit(): void {
    }

}